import { z } from "zod";

import { ORGANIZATION_NAME_FIELD } from "@/constants/organization";

export const onboardingSchema = z.object({
  organizationName: z
    .string()
    .min(1, `${ORGANIZATION_NAME_FIELD.label} is required`),
});

export type OnboardingFormData = z.infer<typeof onboardingSchema>;
